import { render, staticRenderFns } from "./ChatRoomSelector.vue?vue&type=template&id=e4bf75b0&"
import script from "./ChatRoomSelector.vue?vue&type=script&lang=js&"
export * from "./ChatRoomSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports